import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';

import  * as elasticlunr from 'elasticlunr';
import { from } from 'rxjs/observable/from';
import { of } from 'rxjs/observable/of';
import { map, filter , tap, combineAll} from 'rxjs/operators';

@Injectable()
export class SearchService {
  index;
  itemCache: any[];

  resultsSubject: BehaviorSubject<any[]> =  new BehaviorSubject<any[]>([]);
  

  constructor() {
    this.index = elasticlunr(function () {
          this.addField('title');
          this.addField('tags');
          this.setRef('id');
      });

   }

   getResultsSubject(){
      return this.resultsSubject;
   }

  loadSearch(items:any[]){

    this.itemCache = items;

    items.map(obj => {
      this.index.addDoc(obj);
    });

  }

  returnById(id: number):Observable<any> {
    return from(this.itemCache || [])
    .pipe(
      filter(item => item.id == id),
    );
  }

  searchRequest(term: string): any[] {

   const searchResults: any[] =  this.index.search(term,
    {expand: true})
    .map(item => this.index.documentStore.getDoc(item.ref))
    .map(item => {
      this.index.documentStore.getDoc(item.ref)
      // if(item.hasOwnProperty('category')){
      //   item.category_name = item.category[0].category_name;
      // }

      return item;
    });;

    // cache the results
    this.resultsSubject.next(searchResults);

    return searchResults;


  }

}



// WEBPACK FOOTER //
// ./src/app/search.service.ts